import React from "react";
import PropTypes from "prop-types";
import {XIcon} from "@web/assets/icons";
import WorkflowActionLabel from "@web/components/WorkflowActionLabel";
import {Button, List} from 'antd';

InputsManager.propTypes = {
  action: PropTypes.object,
  onClick: PropTypes.func,
};

function InputsManager(props) {
  return <List
    locale={{emptyText: "No Inputs"}}
    dataSource={props.action?.inputPaths || []}
    renderItem={(actionPath) =>
      <List.Item
        extra={
          <Button
            ghost
            className="btn-icon"
            onClick={() => props.onClick?.(actionPath)}
          >
            <XIcon className="green-icon" />
          </Button>
        }>
        <WorkflowActionLabel path={actionPath} className="space space-center-y fat-chip primary" />
      </List.Item>
    }
  />
}

export default InputsManager;
